import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAdapter } from '../api/authAdapter';
import { countdownRepository } from '../api/countdownRepository';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    authAdapter.getCurrentUser().then((currentUser) => {
      if (active) {
        setUser(currentUser);
        setLoading(false);
      }
    });

    const handleAuthExpired = () => {
      setUser(null);
    };

    window.addEventListener('auth-expired', handleAuthExpired);

    return () => {
      active = false;
      window.removeEventListener('auth-expired', handleAuthExpired);
    };
  }, []);

  const login = async (email, password) => {
    const authenticatedUser = await authAdapter.signIn(email, password);
    setUser(authenticatedUser);
    await countdownRepository.migrateGuestData(authenticatedUser.id);
    return authenticatedUser;
  };

  const register = async (email, password) => {
    const authenticatedUser = await authAdapter.signUp(email, password);
    setUser(authenticatedUser);
    await countdownRepository.migrateGuestData(authenticatedUser.id);
    return authenticatedUser;
  };

  const logout = async () => {
    await authAdapter.signOut();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);